// @ts-nocheck
import '../../sass/pages/_cbhomeEncuentros.scss';

import '../components/mordernizr';
import { lazyLoad } from "../components/lazySizes";
import { particles } from "../components/animateParticles";

import Swiper, { Autoplay, Navigation, EffectFade, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

import * as AOS from "aos";
import "aos/dist/aos.css";

import 'animate.css';
import * as Parallax from "parallax-js";

import * as Bouncer from "formbouncerjs";
import { emails } from "../config/constants";


function validateForm() {
  const bouncer = new Bouncer("#interest-eventform", {
    patterns: {
      email:
        /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
    },
    customValidations: {
      emailVerified: function (field: any) {
        if (field.name == "email") {
          let array_email = field.value.split("@");
          const res = emails.find((m: any) => m === array_email[1]);
          return res === undefined ? false : true;
        }
      },
    },
    messages: {
      missingValue: {
        checkbox: "Este campo es obligatorio",
        default: "Este campo es obligatorio",
      },
      emailVerified: "Por favor ingrese un email válido",
      patternMismatch: {
        email: "Por favor ingrese un email válido",
      },
    },
  });
}

function sliderHeader() {
  const swiper = new Swiper("#cb-h-encuentros__slider-header", {
    slidesPerView: 1,
    loop: false,
    cssMode: true,
    autoplay: {
      delay: 5000,
    },
    modules: [Autoplay, Navigation, Pagination],
    pagination: {
      el: "#cb-h-encuentros__slider-header .swiper-pagination",
    },
    navigation: {
      nextEl: "#cb-h-encuentros__slider-header .swiper-button-next",
      prevEl: "#cb-h-encuentros__slider-header .swiper-button-prev",
    },
  });
}

const dataEvent = (page:number, record:number, type:string) => {
  let _datos = {page:page, record:record, type:type }

  fetch(`/co_clubco_convocatorias/encounters`, {
    method: "POST",
    body: JSON.stringify(_datos),
    headers: {
      "Content-Type": "application/json",
    },
  })
  .then(response => response.json())
  .then((json) => {
    if(type == 'next'){
      dataNextEventShow(json);
    }else if(type == 'closed'){
      dataClosedEventShow(json);
    }

  })
  .catch((err: any) => {
    console.log(err)
  });
}

const dataNextEventShow = (data) => {
  let container = document.querySelector('#cb-h-encuentros__slider-nextEvent .swiper-wrapper') as HTMLElement;

  const controlsCss = {
    'backgroundContainer' : container.getAttribute("data-back"),
    'colorText' : container.getAttribute("data-color"),
    'backgroundBtn' : container.getAttribute("data-fondo-btn"),
    'colorTextBtn' : container.getAttribute("data-color-btn"),
    'BorderBtn' : container.getAttribute("data-borde-btn"),
  }

  for(let i = 0; i < data.length; i++){
    container.innerHTML += `
        <div class="swiper-slide" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="0" data-aos-offset="0">
        <div class="cb-h-encuentros__nextEvent-card">
          <img loading="lazy" class="cb-h-encuentros__nextEvent-card--img" src="${data[i].img[0].img}" alt=""/>

          <div loading="lazy" class="cb-h-encuentros__nextEvent-card--content" style="background-image: url('${controlsCss.backgroundContainer}');">
            <h3 style="color: ${controlsCss.colorText}">${data[i].title.substr(0, '20')+"..."}</h3>
            <p class="cb-h-encuentros__nextEvent-card--content-city" style="color: ${controlsCss.colorText}">
              ${data[i].city}
            </p>
            <p class="cb-h-encuentros__nextEvent-card--content-date" style="color: ${controlsCss.colorText}">
              ${data[i].date}
            </p>
            <p class="cb-h-encuentros__nextEvent-card--content-text" style="color: ${controlsCss.colorText}">
              ${data[i].description_short.substr(0, '100')+"..."}
            </p>
            <p class="cb-h-encuentros__nextEvent-card--content-address" style="color: ${controlsCss.colorText}">
              <span></span>
              ${data[i].address}
            </p>

            <a href="${data[i].url}" class="btn-primary" style="background-color: ${controlsCss.backgroundBtn}; color: ${controlsCss.colorTextBtn}; border: 2px solid ${controlsCss.BorderBtn};"  onclick="dataLayerEventosBtn('${data[i].title.substr(0, '20')}');">Conoce más</a>
          </div>
        </div>
      </div>
    `;
  }
  sliderNextEvent();
}

function sliderNextEvent() {
  const swiper = new Swiper("#cb-h-encuentros__slider-nextEvent", {
    slidesPerView: 1,
    spaceBetween: 10,
    modules: [Navigation],
    navigation: {
      nextEl: "#cb-h-encuentros__slider-nextEvent .swiper-button-next",
      prevEl: "#cb-h-encuentros__slider-nextEvent .swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
    },
  });
}
let page = 1;
let max = 0;
const dataClosedEventShow = (data) => {
  if(data.length > 0){
    let container = document.querySelector('.cb-h-encuentros__historical-wrapper .swiper-wrapper') as HTMLElement;

    const controlsCss = {
      'backgroundContainer' : container.getAttribute("data-bg-content"),
      'colorText' : container.getAttribute("data-color-text")
    }

    for(let i = 0; i < data.length; i++){
      let text = data[i].description_closed.split('.');
      const regex = /, basic_html|, full_html|, blog|, embed|, slider|, restricted_html/ig;
      let textClosed = data[i].description_closed.replaceAll(regex, '');
      container.innerHTML = `
          <div class="swiper-slide cb-h-encuentros__historical-card">
          <div class="swiper cb-h-encuentros__historical-card-img">
            <div class="swiper-wrapper"></div>
            <div class="swiper-pagination"></div>
          </div>

          <div class="cb-h-encuentros__historical-card-content" style="background-image: url('${controlsCss.backgroundContainer}');">
            <h3 style="color:${controlsCss.colorText}">${data[i].title}</h3>
            <p class="cb-h-encuentros__historical-card-content-city" style="color:${controlsCss.colorText}">
              ${data[i].city}
            </p>

            <div class="cb-h-encuentros__historical-card-content-text" style="color:${controlsCss.colorText}">
              ${textClosed}
            </div>
          </div>
        </div>
      `;
    }
  }else{
    max = page;
    page=1;
    dataEvent(1,1,'closed');
  }
  dataClosedEventShowImgs(data);
}

const dataClosedEventShowImgs = (data) => {
  let container = document.querySelectorAll('.cb-h-encuentros__historical-card-img .swiper-wrapper') as HTMLElement;
  for(let i = 0; i < data.length; i++){
    for(let j = 0; j < data[i].img.length; j++){
      container[i].innerHTML += `
        <div class="swiper-slide">
          <img loading="lazy" src="${data[i].img[j].img}" alt=""/>
        </div>
      `;
    }
  }
  sliderHistoricalCardImg();
}

const btnShowsHistorical = () => {
  let btnMore = document.querySelector('.cb-h-encuentros__historical .left') as HTMLElement;
  btnMore.addEventListener('click', function(){
    page++;
    dataEvent(page,1,'closed');
  })

  let btnLess = document.querySelector('.cb-h-encuentros__historical .right') as HTMLElement;
  btnLess.addEventListener('click', function(){
    if(page > 1){
      page--;
      dataEvent(page,1,'closed');
    }else{
      page++;
      dataEvent(max,1,'closed');
    }
  })
}

function sliderHistoricalCardImg() {
  const swiper = new Swiper(".cb-h-encuentros__historical-card-img", {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    effect: "fade",
    autoplay: {
      delay: 5000,
    },
    modules: [Autoplay, EffectFade, Pagination],
    pagination: {
      el: ".cb-h-encuentros__historical-card-img .swiper-pagination",
      clickable: true,
    },
  });
}

function ObserverFooter() {
  let isIntersected = false;
  const footer = document.querySelector("#footer__paco");
  const fixedMessage = document.querySelector(".messageFixed");
  let options = {
    threshold: 0.2,
  };

  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        fixedMessage.classList.add("Noshow");
        isIntersected = true;
      } else if (isIntersected == true) {
        fixedMessage?.classList.remove("Noshow");
      }
    });
  }, options);

  observer.observe(footer);
}

function loadParallax() {
  let scene1 = document.querySelector("#scene1");
  let parallax = new Parallax(scene1);

  let scene2 = document.querySelector("#scene2");
  let parallax2 = new Parallax(scene2);
}

(function page() {
  lazyLoad();
  AOS.init({
    once: true,
  });
  sliderHeader();
  validateForm();

  loadParallax();
  dataEvent(1,50,'next');
  dataEvent(1,1,'closed');
  btnShowsHistorical();
  particles('cb-h-encuentros__buy');
})()
/*document.addEventListener('lazybeforeunveil', function(e:any) {
  let bgClass = e.target.getAttribute('data-bg-class');
  if(bgClass) e.target.classList.add(bgClass)
})*/
window.onload = function():void {
  const loading = document.querySelector('#js-loading');
  loading?.classList.add('hidden');
  ObserverFooter();
}
